// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__FXFiu","tabs":"styles_tabs__9sW2T","pane":"styles_pane__bJS-e"};